import download from 'downloadjs';
import API, { defaultHeaders, IRI } from '@/api';

const fetchDownload = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  return fetch(`${API}/panel/course/${IRI.course}${payload.id}/codes`, {headers})
    .then(res => {
      if (res.status !== 200) {
        throw Error('Invalid download status');
      }

      return res.blob();
    })
    .then(blob => download(blob, `${payload.title}.csv`, 'text/csv'))
    .catch(e => console.error(e))
  ;
};

export default fetchDownload;
